import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { siteParams } from '../../config/site';
import Newspaper from '../../components/Newspaper';
import { Creators as NewspapersCreators } from '../../store/ducks/newspapers';

class Home extends Component {
  static propTypes = {
    getRecents: PropTypes.func.isRequired,
    getHighlights: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.props.getRecents();
    this.props.getHighlights();
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 6,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
    };
    return (
      <Fragment>
        <div className="home-main">
          <div className="home-banner d-none d-sm-block">
            <Link to="/jornais/todos">{siteParams.home.imgBanner}</Link>
          </div>
          <div className="row justify-content-center">
            <div className="col-10">
              <h1>Jornais Recentes</h1>
              <Slider {...{ ...settings, infinite: this.props.newspapers.recents.data.lenght > 1 }}>
                {this.props.newspapers.recents.data.map(newspaper => (
                  <Newspaper newspaper={newspaper} key={newspaper.edition.id} />
                ))}
              </Slider>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-10">
              <h1>Jornais em Destaque</h1>
              <Slider
                {...{ ...settings, infinite: this.props.newspapers.highlights.data.lenght > 1 }}
              >
                {this.props.newspapers.highlights.data.map(newspaper => (
                  <Newspaper newspaper={newspaper} key={newspaper.edition.id} />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  newspapers: state.newspapers,
});

const mapDispatchToProps = dispatch => bindActionCreators(NewspapersCreators, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Home);



// WEBPACK FOOTER //
// ./src/pages/home/index.js